throw new Error('This module is not supposed to be imported!');


/*****************
 ** WEBPACK FOOTER
 ** ./~/vertx3-full/index.js
 ** module id = 694
 ** module chunks = 1
 **/